import { ThemeProvider, createMuiTheme } from "@material-ui/core";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import { one as themeConfig } from "./ui/ViTheme";
import { ErrorProvider } from "./contexts/ErrorContext";
import { FeatureFlagsProvider } from "./contexts/FeatureFlags";
import { AppProvider } from "./contexts/AppContext";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

const theme = createMuiTheme({
  ...themeConfig,
  palette: { ...themeConfig.palette /* type: "dark" */ },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <ErrorProvider>
      <AppProvider>
        <AuthProvider>
          <FeatureFlagsProvider>
            <App />
          </FeatureFlagsProvider>
        </AuthProvider>
      </AppProvider>
    </ErrorProvider>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
